export default "__VITE_ASSET__db2ece5d__"